<template lang="pug">
  div#minitries
    .parallax.mb-0.imageTop
      v-row(align="center" justify="center" style="height:100%")
        v-col(cols="12" align="center")
          p.display-3.font-weight-black.ministires-title Our Ministries
    //- .display-2.text-center LOVE is a DO Word!
    v-row(justify="center")
      v-col.pa-0(cols="12" align="center")
        v-img.align-center( src="../assets/img/1x/SVG/LoveIs.svg" width="100%" align-center )
    router-view 
</template>

<script>
export default {};
</script>

<style lang="stylus" scoped>
.v-image__image.v-image__image--cover
  top -75px !important
  min-height 450px !important

.ministires-title
  font-family Cardo, 'san-serif' !important

.parallax
  background-image url('../assets/img/crossStain.jpg')
  height 355px
  background-attachment fixed
  background-position top
  background-repeat no-repeat
  background-size cover
  color white
</style>
